import React, { useContext, useEffect } from 'react';
import { useRenditions } from '@yme/common/hooks';
import { View360Context } from './View360Context';
import { View360ImageStyled } from './styled';
const imagesCached = {};
let loadedImages = 0;
const cacheImage = (src) => {
    if (!src)
        return '';
    if (!imagesCached[src]) {
        imagesCached[src] = new Promise((resolve) => {
            const image = new Image();
            image.onload = () => {
                imagesCached[src] = true;
                resolve(imagesCached[src]);
            };
            image.src = src;
        }).then(() => {
            imagesCached[src] = true;
            loadedImages += 1;
        });
    }
    if (imagesCached[src] instanceof Promise) {
        throw imagesCached[src];
    }
    return imagesCached[src];
};
export function View360Image({ url, altText }) {
    const { setImagesLoaderCounter } = useContext(View360Context);
    const { imageSrcWithDimension } = useRenditions({
        imageSrc: url,
    });
    useEffect(() => {
        setImagesLoaderCounter(loadedImages);
    }, [setImagesLoaderCounter]);
    useEffect(() => {
        return () => {
            if (loadedImages !== 0) {
                loadedImages = 0;
            }
        };
    }, []);
    cacheImage(imageSrcWithDimension);
    return (React.createElement(View360ImageStyled, { src: imageSrcWithDimension, alt: altText, draggable: false }));
}
